/* Ronsoco Returns page: topic list (desktop) and tap-to-open topics (phones); #anchor opens that topic */
(() => {
  const desktop = window.matchMedia('(min-width: 990px)');

  const setOpen = (root, panel, open) => {
    panel.classList.toggle('is-open', open);
    panel.querySelector('[data-rrp-toggle]')?.setAttribute('aria-expanded', String(open));
  };

  const show = (root, id, scroll) => {
    const target = root.querySelector(`[data-rrp-panel="${id}"]`);
    if (!target) return;
    root.querySelectorAll('[data-rrp-panel]').forEach((panel) => setOpen(root, panel, panel === target));
    root.querySelectorAll('[data-rrp-tab]').forEach((tab) => {
      if (tab.dataset.rrpTab === id) tab.setAttribute('aria-current', 'true');
      else tab.removeAttribute('aria-current');
    });
    if (scroll) target.scrollIntoView({ block: 'start' });
  };

  const fromHash = (root, scroll) => {
    const hash = decodeURIComponent(window.location.hash.slice(1));
    const panel = hash && root.querySelector(`[data-rrp-panel][id="${CSS.escape(hash)}"]`);
    if (panel) show(root, panel.dataset.rrpPanel, scroll);
  };

  const init = (root) => {
    if (root.dataset.rrpReady) return;
    root.dataset.rrpReady = 'true';

    root.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-rrp-tab]');
      if (tab) {
        event.preventDefault();
        show(root, tab.dataset.rrpTab, false);
        window.history.replaceState(null, '', tab.getAttribute('href'));
        return;
      }
      const toggle = event.target.closest('[data-rrp-toggle]');
      if (toggle && !desktop.matches) {
        const panel = toggle.closest('[data-rrp-panel]');
        setOpen(root, panel, !panel.classList.contains('is-open'));
      }
    });

    // Back on desktop, only one topic shows: keep the first open one
    desktop.addEventListener('change', () => {
      if (!desktop.matches) return;
      const open = root.querySelector('[data-rrp-panel].is-open') || root.querySelector('[data-rrp-panel]');
      if (open) show(root, open.dataset.rrpPanel, false);
    });

    fromHash(root, true);
    window.addEventListener('hashchange', () => fromHash(root, true));
  };

  const start = () => document.querySelectorAll('[data-rrp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest('[data-rrp]');
    const id = event.target.dataset.rrpTab || event.target.dataset.rrpPanel;
    if (root && id) show(root, id, false);
  });
})();
